import { apiClient, unwrap } from './client';
import type { ApiResponse } from '@/types/api';

export interface ComplianceSummaryDto {
  totalDevices: number;
  activeDevices: number;
  offlineDevices: number;
  pendingEnrollment: number;
  withoutProfile: number;
  unauthorizedApps: number;
  outdatedSystem: number;
  androidVersionDistribution: Record<string, number>;
  brandDistribution: Record<string, number>;
  stateDistribution: Record<string, number>;
}

export interface ComplianceItemDto {
  deviceId: number;
  serialNumber?: string | null;
  model?: string | null;
  assignedToName?: string | null;
  profileName?: string | null;
  enterpriseName: string;
  lastSyncAt?: string | null;
  issue: string;
  severity: 'info' | 'warning' | 'error';
}

export interface ComplianceFilter {
  enterpriseId?: number;
  offlineDays?: number;
  outdatedSystemDays?: number;
}

export const complianceApi = {
  getSummary(filter: ComplianceFilter = {}): Promise<ComplianceSummaryDto> {
    return unwrap(
      apiClient.get<ApiResponse<ComplianceSummaryDto>>('/compliance/summary', { params: filter }),
    );
  },
  getOffline(filter: ComplianceFilter = {}): Promise<ComplianceItemDto[]> {
    return unwrap(
      apiClient.get<ApiResponse<ComplianceItemDto[]>>('/compliance/offline', { params: filter }),
    );
  },
  getWithoutProfile(filter: ComplianceFilter = {}): Promise<ComplianceItemDto[]> {
    return unwrap(
      apiClient.get<ApiResponse<ComplianceItemDto[]>>('/compliance/without-profile', { params: filter }),
    );
  },
  getPendingEnrollment(filter: ComplianceFilter = {}): Promise<ComplianceItemDto[]> {
    return unwrap(
      apiClient.get<ApiResponse<ComplianceItemDto[]>>('/compliance/pending-enrollment', { params: filter }),
    );
  },
};
